export var DefaultTransition = {
    ActionType: null,
    State: null,
    Params: {},
    URL: null
};
//# sourceMappingURL=transistion.model.js.map